import { checkStatusForLogin } from 'shared/helpers/checkStatus'
import { axiosInstance } from 'network/apis';

const getUserInfoRequest = async (userId) => {
  return await axiosInstance.get(`user/user-info/${userId}`,  { handlerEnabled: true })
};

const getCognitoUserInfoRequest = async (userId) => {
  return await axiosInstance.get(`user/user-info/${userId}`, {params: {cognito: '1'}},  { handlerEnabled: true })
};
  
function loginUserFromComms (conferenceHash, userHash) {
    return fetch(`/v1/conf/${conferenceHash}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userHash }),
    })
    .then(checkStatusForLogin)
    .then(res => res.json())
  }
   
  export const updateUserTimezone = async (payload) => {
    return axiosInstance.post(`user/upsert-user-time-zone-selection`,{ userId: payload.userId, userSelectedTimeZone: payload.timezone } ,{ handlerEnabled: true })
  };

  export const matchCurrentPassword = async ({password, userId}) => {
    return axiosInstance.put(`reset-user-password/check-if-password-matches/${userId}`,{  password: password  } ,{ handlerEnabled: true })
  };

  export const putUserPasword = async (payload) => {
    return axiosInstance.patch(`reset-user-password/patch-user-from-profile/${payload.userId}`,{ password: payload.password } ,{ handlerEnabled: true })
   };

  export const fetchAllUsersDetails = async () => {
    return axiosInstance.get(`qstoolAdmin/get-all-users`,{ handlerEnabled: true })
   }; 

   // QUAL-2135: this used to POST to the public unsubscribe route with `handlerEnabled: false`
   // - i.e. deliberately WITHOUT the Authorization header - and the API told the admin action
   // apart from a recipient clicking an unsubscribe link purely by this body carrying a
   // pmUserId. Any caller could send that field, so the whole admin action was reachable
   // unauthenticated, including to opt a user back IN.
   //
   // It now posts to a Cognito-authorised route with the operator's token attached, and
   // pmUserId is dropped: the API takes it from the verified custom:userId claim, because that
   // value becomes the created_by / modified_by audit record for the consent change. The
   // response shape is unchanged - userSaga reads response.data[3].records[0].modified_date.
   export const updateAllowContactByEmail = async (payload) => {
    return axiosInstance.post(`unsubscribe/user-comm-preference/${payload.userId}`,{ allowContactByEmail: payload.allowContactByEmail } ,{ handlerEnabled: true })
   };
 
export default{
    getUserInfoRequest,
    getCognitoUserInfoRequest,
    loginUserFromComms,
    matchCurrentPassword,
    putUserPasword,
    updateUserTimezone,
    fetchAllUsersDetails,
    updateAllowContactByEmail
}
